import React from 'react';
import {
	Label,
} from '@ascension/web';
import { Box } from '@material-ui/core';
import { useFieldFormContext } from '@utilities/hooks/useFieldFormContext/useFieldFormContext';
import { useTimeFormContext } from '@utilities/hooks/useTimeFormContext/useTimeFormContext';
import { PreAdmitTestSubformValidation } from './PreAdmitTestSubformValidation';
import PreAdmitTestSubformProps from './PreAdmitTestSubformProps';
import DateInputPicker from '@components/DateInputPicker/DateInputPicker';
import TimePicker from '@components/TimePicker/TimePicker';
import TextFieldInput from '@components/TextFieldInput/TextFieldInput';
import { StatefulSelect } from '@components/StatefulInputs/StatefulSelect/StatefulSelect';
import { SelectOption } from '@components/StatefulInputs/StatefulSelect/StatefulSelect.types';
import { createStyles, makeStyles } from '@mui-core-real';

const useStyles = makeStyles((theme) =>
	createStyles({
		select: {
			'width': '50%',
			'padding': theme.spacing(2, 0, 2, 0),
			'& .MuiInputLabel-root': {
				fontSize: '0.75rem',
				paddingBottom: theme.spacing(0.15),
				color: theme.palette.common.black,
				fontWeight: 550,
			},
			'& .MuiSelect-select > span': {
				fontSize: '1rem',
				color: theme.palette.grey[500],
			},
		},
		locationRow: {
			display: 'flex',
			alignItems: 'flex-end',
			gap: theme.spacing(2),
		},
	}),
);

const patLocationOptions: SelectOption[] = [
	{ value: 'PAT', label: 'PAT' },
	{ value: 'POMC', label: 'POMC' },
	{ value: 'Other', label: 'Other' },
];

const PreAdmitTestSubform = ({ isEdit }: PreAdmitTestSubformProps) => {
	const classes = useStyles();
	const {
		currentPeriodValue,
		currentTimeValue,
		currentDateValue,
		setPeriodValue,
		setTimeValue,
		setDateValue,
		dateError,
		triggerDateValidation
	} = useTimeFormContext('pat', {
		datePickerValidation: isEdit ? PreAdmitTestSubformValidation.patDateEdit : PreAdmitTestSubformValidation.patDate,
	});

	const {
		currentValue: patLocation,
	} = useFieldFormContext<string>('patLocation');

	const {
		currentValue: patOtherLocation,
		setCurrentValue: setPatOtherLocation,
		error: patOtherLocationError,
	} = useFieldFormContext<string>('patOtherLocation');

	return (<>
		<Box className={classes.locationRow}>
			<StatefulSelect
				placeholder="Select"
				name="patLocation"
				label="WHERE IS PAT TAKING PLACE?"
				dataField="procedureForm-patLocation"
				options={patLocationOptions}
				wrapperClassName={classes.select}
				styleAsRequired={true}
				controllerOptions={{
					rules: PreAdmitTestSubformValidation.patLocation,
				}}
			/>
			{patLocation === 'Other' &&
				<TextFieldInput
					fullWidth
					name="patOtherLocation"
					fieldName="patOtherLocation"
					placeholder="Enter Location"
					value={patOtherLocation}
					errorMessage={patOtherLocationError}
					onChange={setPatOtherLocation}
				/>
			}
		</Box>
		<Box data-field="PAT_DateTimeLabel" mt={1}>
			<Label>
				Requested PAT appointment date and time (if known)
			</Label>
		</Box>
		<Box display="flex" flexDirection="row">
			<Box data-field="PAT_Date" className="margin-right-16">
				<DateInputPicker
					currentDate={currentDateValue}
					onValidDateChange={setDateValue}
					errorMessage={dateError}
					onBlur={triggerDateValidation}
				/>
			</Box>
			<Box data-field="PAT_Time">
				<TimePicker
					name="patTime"
					disabled={!currentDateValue}
					onTimeChange={setTimeValue}
					onPeriodChange={setPeriodValue}
					value={currentDateValue ? currentTimeValue : ''}
					periodValue={currentPeriodValue}
				/>
			</Box>
		</Box>
	</>);
};

export default PreAdmitTestSubform;
